import GoogleIcon from '@mui/icons-material/Google';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import { ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useAppSelector } from '../../../store/hooks';
import DialogConfirmAction from '../DialogConfirmAction/DialogConfirmAction';

const useStyles = makeStyles()((theme: Theme) => ({
    selectWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        //margin: theme.spacing(1, 0)
    },
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
    listItem: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textDecoration: 'none',
    },
    listItemName: {
        margin: 0,
    },
}));

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{ userName: string }>;
    value: string;
};

export default function SelectUser({ onSelectHandler, value, ...props }: Props) {
    const { showModal } = useModal();
    const { classes } = useStyles();

    const users = useAppSelector(state => state.user.users);

    const [confirmedUser, setConfirmedUser] = React.useState<string>(value);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Select Owner',
            description: 'Are you sure you want to change owner?',
            onConfirm: () => {
                setConfirmedUser(event.target.value);
                onSelectHandler({ userName: event.target.value });
            },
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <TextField
            className={classes.selectWrapper}
            {...(props as TextFieldProps)}
            select
            value={confirmedUser}
            id={props.id || 'select_user'}
            label={props.label || 'Select User'}
            onChange={handleSelect}
        >
            {users.map(user => (
                <MenuItem key={user.userName} value={user.userName} className={classes.menuItem}>
                    <div className={classes.listItem}>
                        <ListItemText className={classes.listItemName}>
                            {user.userName}
                        </ListItemText>
                        <ListItemIcon>
                            {user.userEmailId && (
                                <Tooltip title={`Connected to ${user.userEmailId}`}>
                                    <MailIcon fontSize="small" />
                                </Tooltip>
                            )}
                            {user.googleAccountId && (
                                <Tooltip title={`Google Account: ${user.googleAccountId}`}>
                                    <GoogleIcon fontSize="small" />
                                </Tooltip>
                            )}
                            {user.twilioPhoneNumber && (
                                <Tooltip title={`Virutal Phone: ${user.twilioPhoneNumber}`}>
                                    <PhoneIcon fontSize="small" />
                                </Tooltip>
                            )}
                        </ListItemIcon>
                    </div>
                </MenuItem>
            ))}
        </TextField>
    );
}
